export const en = {
  // Loading
  loading: "Loading survey...",
  
  // Thank you page
  thankYou: "Thank You!",
  surveySubmitted: "Your survey response has already been submitted.",
  appreciateParticipation: "We appreciate your participation and feedback.",
  
  // Survey closed page
  surveyClosed: "This survey is not accepting additional responses at this time. Thank You!",
  
  // Error page
  invalidSurveyLink: "This is not a valid survey link.",
  surveyLoadError: "The survey could not be loaded. Please check the URL and try again.",
  
  // No survey data page
  noSurveyAvailable: "No Survey Available",
  surveyNotFound: "The survey you're looking for could not be found or is no longer available.",
  
  // Invalid URL page
  invalidSurveyUrl: "Invalid Survey URL",
  invalidUrlMessage: "The survey link is not valid. Please check the URL and try again.",
  
  // Survey renderer errors
  submitFailed: "Failed to submit survey response. Please try again.",
  
  // PIN Landing Page
  pinWelcome: "Welcome! Please enter your PIN to begin.",
  pinInstructions: "You should have received a PIN from your organization. Enter it below to access the survey. PINs are not case-sensitive.",
  enterYourPin: "Enter your PIN",
  pinPlaceholder: "e.g., ABC123 or 987654",
  pinError: "Invalid PIN. Please try again.",
  submit: "Submit",
  submitting: "Submitting...",
  pinNeedHelp: "Need help? Contact your HR administrator for assistance.",
  poweredByTalentMap: "Powered by TalentMap",
};

export type TranslationKeys = typeof en;

